import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize, takeWhile } from 'rxjs';

import { IPanel, PanelsService } from '@app/core/panels';

@Component({
  selector: 'app-panel-dialog',
  templateUrl: './panel-dialog.component.html',
})
export class PanelDialogComponent implements OnDestroy {
  public form: FormGroup;
  public saving: boolean;

  private destroyed: boolean;
  private panel: IPanel;

  constructor(
    cfg: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private service: PanelsService
  ) {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      allowedProfiles: new FormControl(''),
    });

    if (cfg.data?.panel) {
      this.panel = cfg.data.panel;
      console.log('PanelDialogComponent: panel', this.panel);
      this.form.patchValue(this.panel);
    }
  }

  public saveChanges(): void {
    this.form.markAllAsTouched();

    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).markAsDirty();
    });

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    const op = !this.panel
      ? this.service.createPanel({ ...this.form.value })
      : this.service.updatePanel({ ...this.panel, ...this.form.value });

    op.pipe(
      takeWhile(() => !this.destroyed),
      finalize(() => (this.saving = false))
    ).subscribe((panel) => {
      this.dialogRef.close(panel);
    });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
